import siteLogo from "../assets/images/site-logo.svg";
import siteFooterLogo from "../assets/images/footer-logo.svg";
import excavator from "../assets/images/excavator.png";
import PhoneIcon from "../assets/images/icons/tele-phone-icon.svg";
import FancyCornerIcon from "../assets/images/icons/fancy-corner-icon.svg";
import FancyWhiteCornerIcon from "../assets/images/icons/white-fancy-corner-icon.svg";
import EarthIcon from "../assets/images/icons/earcth-icon.svg";
import BuildingIcon from "../assets/images/icons/building-icon.svg";
import ConcreteIcon from "../assets/images/icons/concrete-icon.svg";
import HandshakeIcon from "../assets/images/icons/handshake-icon.svg";
import User1 from "../assets/images/icons/user1-icon.png";
import User2 from "../assets/images/icons/user2-icon.png";
import MapImg from "../assets/images/map-img.png";
import Featuredimg1 from "../assets/images/our-featured-img.jpg";
import Earthworkimg1 from "../assets/images/earthwork-img1.png";
import Earthworkimg2 from "../assets/images/earthwork-img2.png";
import Earthworkimg3 from "../assets/images/earthwork-img3.png";
import Earthworkimg4 from "../assets/images/earthwork-img4.png";
import Earthworkimg5 from "../assets/images/earthwork-img5.png";
import concreteImg1 from "../assets/images/concreteImg1.png";
import concreteImg2 from "../assets/images/concreteImg2.png";
import concreteImg3 from "../assets/images/concreteImg3.png";
import concreteImg4 from "../assets/images/concreteImg4.png";
import utilitieImg1 from "../assets/images/utilitieImg1.png";
import utilitieImg2 from "../assets/images/utilitieImg2.png";
import utilitieImg3 from "../assets/images/utilitieImg3.png";
import utilitieImg4 from "../assets/images/utilitieImg4.png";
import utilitieImg5 from "../assets/images/utilitieImg5.png";
import emergenciImg1 from "../assets/images/emergenciImg1.png";
import emergenciImg2 from "../assets/images/emergenciImg2.png";
import emergenciImg3 from "../assets/images/emergenciImg3.png";
import emergenciImg4 from "../assets/images/emergenciImg4.png";
import SaftyImg1 from "../assets/images/safty-img1.png";
import SaftyImg2 from "../assets/images/safty-img2.png";
import SaftyImg3 from "../assets/images/safty-img3.jpg";


export const Images = {
    siteLogo,
    siteFooterLogo,
    excavator,
    PhoneIcon,
    FancyCornerIcon,
    FancyWhiteCornerIcon,
    EarthIcon,
    BuildingIcon,
    ConcreteIcon,
    HandshakeIcon,
    User1,
    User2,
    MapImg,
    Featuredimg1,
    Earthworkimg1,
    Earthworkimg2,
    Earthworkimg3,
    Earthworkimg4,
    Earthworkimg5,
    concreteImg1,
    concreteImg2,
    concreteImg3,
    concreteImg4,
    utilitieImg1,
    utilitieImg2,
    utilitieImg3,
    utilitieImg4,
    utilitieImg5,
    emergenciImg1,
    emergenciImg2,
    emergenciImg3,
    emergenciImg4,
    SaftyImg1,
    SaftyImg2,
    SaftyImg3,
};
